import { ProfileExtrusionType } from "building-types/profiles/profileTypesEnum";
import type { RoofGenerationStageInput, RoofGenerationStageResult } from "building-types/roofs/roofGenerationTypes";
import { WallRoofBaseBoardMode, WallRoofBaseBoardFilter } from "building-types/settings/settingsTypesEnum";
import { resolvedGableVent } from "../roofSideOverridesUtility";

/**
 * Generates the basic parameters of a multi-gable roof, including the roof settings,
 * heel height offsets, base height, and the overhang values for the different sides.
 */
export function generateRoofBasicParameters({
  subRoof,
  subRoofOptions,
}: RoofGenerationStageInput): RoofGenerationStageResult {
  const { roofInputSettings, wallMaterial, roofData } = subRoofOptions;
  const { roofSettings } = subRoof;
  const { roofFramingSettings, exteriorTrimSettings } = roofInputSettings;

  const {
    wallRoofBaseBoard = exteriorTrimSettings.wallRoofBaseBoard ?? WallRoofBaseBoardMode.NONE,
    wallRoofBaseBoardFilter = exteriorTrimSettings.wallRoofBaseBoardFilter ?? WallRoofBaseBoardFilter.ALL_EDGES,
    wallRoofBaseBoardProfile = exteriorTrimSettings.wallRoofBaseBoardProfile ?? ProfileExtrusionType.NONE,
    suppressWallExtension,
    roofSideOverrides,
    gableEndLabels = [],
  } = roofData;

  //copy gable vent from side to subroof - only need to do it once here as it gets used in a later building generation stage
  const gableVents = resolvedGableVent(roofSettings, roofSideOverrides);

  return {
    subRoof: {
      roofSettings,
      roofFramingSettings,
      wallMaterial,
      wallRoofBaseBoard,
      wallRoofBaseBoardFilter,
      wallRoofBaseBoardProfile,
      suppressWallExtension,
      gableEndLabels,
      gableVents,
    },
  };
}
